export default "__VITE_ASSET__lGF9ywBQ__"